export default __webpack_public_path__ + "static/media/dtt-large.dc1b93ab.jpg";